// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3TL_7","range":"MonthRangeSwitch_range__iYsu3","disabled":"MonthRangeSwitch_disabled__1oSC0"};